export default {
  reviewsCount: {
    id: 'models_comparison_results_reviews_count',
    defaultMessage: '{count} reviews',
  },
} as const
